import * as Backbone from 'backbone';
import * as _ from 'underscore';

import config from '../../common/config';

export var Model = Backbone.Model.extend({
    errors: [],
    initialize: function () {
        var that = this;
    },
    validateNoBackbone: function (attrs, app, callback) {
        this.errors = [];

        var self = this;

        if (!attrs.Name || attrs.Name.length < 0) {
            self.errors.push({ name: 'infoScreenContact_inputName', message: resources.X100324 });
        }

        if (!attrs.EmailFrom || attrs.EmailFrom.length < 0) {
            self.errors.push({ name: 'infoScreenContact_inputEmailFrom', message: resources.X100324 });
        } else {
            //var validate_EmailFrom = '^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$';
            //var validate_EmailFrom = "[\w-]+@([\w-]+\.)+[\w-]+";
            var validate_EmailFrom = app.entities.collections.publicConfigSubscriptionValidate.where( {Name : 'register_inputEmail'});
        
            if (validate_EmailFrom || validate_EmailFrom.length > 0) {
                var re = new RegExp(validate_EmailFrom[0].attributes.Value, 'g');
                if(attrs.EmailFrom.match(re) == null) {
                    self.errors.push({ name: 'infoScreenContact_inputEmailFrom', message: resources.X100669 });
                }
            }
        }

        if (!attrs.Phone || attrs.Phone.length < 0) {
            self.errors.push({ name: 'infoScreenContact_inputPhone', message: resources.X100324 });
        }

        //if (!attrs.Subject || attrs.Subject.length < 0) {
        //    self.errors.push({ name: 'infoScreenContact_inputSubject', message: resources.X100324 });
        //}

        //if (!attrs.Body || attrs.Body.length < 0) {
        //    self.errors.push({ name: 'infoScreenContact_textareaBody', message: resources.X100324 });
        //}

        if (self.errors.length <= 0) {
            callback(true);
        }
        else {
            callback(false);
        }
    },
    constructor: function () {
        this.defaults = _.extend({}, this.defaults, {
            Calculation: {}
        });

        Backbone.Model.prototype.constructor.apply(this, arguments);
    },
    "sync": function (method, model, options) {
        if (method == 'read') {
            options.url =  config.webApiUrl() + '/api/publicRecaptcha/-1';
        } else if (method == 'create') {
            options.url =  config.webApiUrl() + '/api/publicRecaptcha/' + options.route + '/-1';
        } 
        return Backbone.sync(method, model, options);
    }
});

